export enum QRCodeStatus {
  PENDING = 'pending',
  SCANNED = 'scanned',
  CONFIRMED = 'confirmed',
  CANCELED = 'canceled',
  EXPIRED = 'expired'
}

export interface QRCodeData {
  qrCode: string;
  loginKey: string;
  expireTime: number;
}